export default [
    {
        key: "selected",
        label: app.$i18n.t(""),
        sortable: false,
        visible: true,
    },
    {
        key: "full_name",
        label: app.$i18n.t("full name"),
        sortable: true,
        visible: true,
    },
    {
        key: "area",
        label: app.$i18n.t("Area"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    {
        key: "personal_type",
        label: app.$i18n.t("Personal Type"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    // {
    //     key: "start_date",
    //     label: app.$i18n.t("Start Date"),
    //     sortable: true,
    //     visible: true,
    // },
    // {
    //     key: "license_number",
    //     label: app.$i18n.t("License Number"),
    //     sortable: true,
    //     visible: true,
    // },
    {
        key: "group_entity",
        label: app.$i18n.t("entity group"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    {
        key: "sunday",
        label: "D",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    {
        key: "monday",
        label: "L",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    {
        key: "tuesday",
        label: "M",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    {
        key: "wednesday",
        label: "X",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    {
        key: "thursday",
        label: "J",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    {
        key: "friday",
        label: "V",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    {
        key: "saturday",
        label: "S",
        sortable: false,
        visible: true,
        tdClass: "mw text-center",
        thClass: "text-center"
    },
    // {
    //     key: "personal_code",
    //     label: app.$i18n.t("personal code"),
    //     sortable: true,
    //     visible: true,
    // },
    // {
    //     key: "document_number",
    //     label: app.$i18n.t("Document Number"),
    //     sortable: true,
    //     visible: true,
    // },

    // {
    //     key: "address",
    //     label: app.$i18n.t("address"),
    //     sortable: true,
    //     visible: true,
    // },
    // {
    //     key: "cell_phone",
    //     label: app.$i18n.t("Cell Phone"),
    //     visible: true,
    // },

    {
        key: "status",
        label: app.$i18n.t("Status"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    {
        key: 'fecha_cese',
        label: 'Info Cese',
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    {
        key: "vacations",
        label: app.$i18n.t("vacations"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    {
        key: "schedule_id",
        label: app.$i18n.t("Schedule"),
        sortable: true,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
    {
        key: "actions",
        label: app.$i18n.t("Actions"),
        sortable: false,
        visible: true,
        tdClass: "text-center",
        thClass: "text-center"
    },
]